import React from 'react';
import PropTypes from 'prop-types';

import { ListItem as MuiListItem } from '@material-ui/core';

const ListItem = ({ children, ...rest }) => {
  return (
    <MuiListItem
      {...rest}
    >
      { children }
    </MuiListItem>
  )
}

ListItem.defaultProps = {
  children: null,
}

ListItem.propTypes = {
  children: PropTypes.node,
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/base/ListItem/ListItem.js